import { render } from "./SidebarInfo.vue?vue&type=template&id=3687e9b8&ts=true"
import script from "./SidebarInfo.vue?vue&type=script&lang=ts"
export * from "./SidebarInfo.vue?vue&type=script&lang=ts"

import "./SidebarInfo.vue?vue&type=style&index=0&id=3687e9b8&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__